















import Vue from 'vue'
import { Route } from 'vue-router'
import logo from '@/components/globals/logo.vue'

export default Vue.extend({
  data() {
    return {
      isHome: true
    }
  },
  components: { logo },
  created() {
    this.isHome = this.$route.name === 'home' ? true : false
  },
  watch: {
    $route(to: Route) {
      this.isHome = to.name === 'home' ? true : false
    }
  }
})
